import { combineReducers } from 'redux'
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer}  from 'redux-firestore'

//import postsBySubreddit, { selectedSubreddit} from './examples/async/reducers'
import { todos, visibilityFilter } from './examples/todo/reducers'
import { cps } from './examples/cps/reducers'
import { permissions, selectedActivityId, cpsByActivityId } from './examples/firestore/reducers'


import { activitiesByAssessmentId, selectedAssessment, assessments, 
          summarizedCps,  breadcrumbs, employeeById, asyncMessage } from './assessments/reducers'
import { selectedActivity, updateText, updateAnswer, dimensionAnswer } from './activities/reducers'
import { noteText } from './modules/notes/reducers'

import { testClicked} from './test/reducers'

import assessment from './modules/activities/reducers'
import competencies from './modules/competencies/reducers'
/*
import { updateText } from './levels/reducers'
import { updateAnswer, answer } from './indicators/reducers'  

import { assessmentsByRaterId, selectedRaterId} from './assessments/reducers'
import { activitiesByAssessmentId, selectedAssessmentId} from './assessment/reducers'
import { activitiesByAssessmentId, selectedAssessmentId } from './activities/reducers'
*/

import {adminState} from './admin/reducers'

function errorMessage(message = {},action ){
  switch (action.type) {
    case 'ERROR':
      return { id: action.id,message: action.message}
    default:
      return message
  }
}

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  assessments,
  
  errorMessage,



  activitiesByAssessmentId,
  selectedAssessment,
  selectedActivity,
  summarizedCps,


  breadcrumbs,
  employeeById,

  updateAnswer,
  dimensionAnswer,
  noteText,

  assessment,
  competencies,

  todos,
  visibilityFilter,

  cps,
  asyncMessage,

/*
  assessmentsByRaterId,
  selectedRaterId,
*/

  permissions,

  selectedActivityId,
  cpsByActivityId,

  testClicked,

  adminState

})


// WEBPACK FOOTER //
// ./src/reducers.js